import { createSelector } from 'reselect';
import { selectors } from '@saucelabs/sl-module-performance';

import { METRICS_HISTORY_DATA_SIZE } from '../../constants';
import { getPerfType } from '../../utils';

const extendedDebuggingContainerStore = (store) => store.apps.extendedDebugging.container;
const performanceHistoryStore = (store) => store.apps.extendedDebugging.performanceHistory;
const baselineSelectedJobStore = (store) => store.apps.extendedDebugging
  .performanceHistory.selectedBaselineJob;

export const performanceHistorySelector = createSelector(
  extendedDebuggingContainerStore,
  performanceHistoryStore,
  selectors.routerQuerySelector,
  (container, performanceHistory, routerQuery) => ({
    defaultMetricsList: routerQuery.metrics,
    loading: performanceHistory.common.get('loading'),
    jobId: container.getIn(['job', 'id']),
    jobInfo: performanceHistory.jobMetrics.get('jobInfo'),
    urlList: performanceHistory.jobMetrics.get('urlList'),
    isMetricsHistoryAvailable: performanceHistory.metricHistory.get('isMetricsHistoryAvailable'),
    metricsHistoryDetail: performanceHistory.metricHistory.get('metricsHistoryDetail'),
    isBaselineDataSufficient: performanceHistory.common.get('isBaselineDataSufficient'),
    loadingMetricsHistoryDetail: performanceHistory.metricHistory.get('loadingMetricsHistoryDetail'),
    selectedMetrics: performanceHistory.common.get('selectedMetrics'),
    pageIndex: container.get('pageIndex'),
    shouldCallInit: container.get('shouldCallInit'),
    isBaselineJobSelected: !!performanceHistory.selectedBaselineJob.get('selectedBaselineChartPayload'),
    failure: performanceHistory.common.get('failure'),
    perfType: performanceHistory.common.get('perfType'),
  }),
);

export const metricHistoryFilterSelector = createSelector([
  extendedDebuggingContainerStore,
  performanceHistoryStore,
  selectors.routerQuerySelector,
  (store, options) => options,
], (container, performanceHistory, routerQuery, options) => {
  const { additionalParams = {} } = options;
  const orderIndex = options.orderIndex || performanceHistory.common.get('orderIndex');
  const selectedPageInfo = performanceHistory.jobMetrics.getIn(['jobData', orderIndex]);
  const selectedMetrics = (options.selectedMetrics || performanceHistory.common.get('selectedMetrics'))
    .map(({ name }) => name);
  const metricHistoryQueryParams = {
    auth: routerQuery.auth,
    page_url: selectedPageInfo.page_url,
    order_index: selectedPageInfo.order_index,
    metric_names: selectedMetrics,
    limit: METRICS_HISTORY_DATA_SIZE,
  };
  return {
    jobId: container.getIn(['job', 'id']),
    params: { ...metricHistoryQueryParams, ...additionalParams },
  };
});

export const jobInfoSelector = createSelector(
  (store) => ({
    performanceHistory: store.apps.extendedDebugging.performanceHistory,
  }), ({ performanceHistory }) => performanceHistory.jobMetrics.get('jobInfo'),
);

export const selectedBaselineJobSelector = createSelector(
  baselineSelectedJobStore,
  (baselineSelectedJob) => ({
    loading: baselineSelectedJob.get('loadingJobData'),
    jobInfo: baselineSelectedJob.get('jobInfo'),
    failure: baselineSelectedJob.get('failure'),
  }),
);

export const fetchJobDataSelector = createSelector([
  performanceHistoryStore,
  selectors.routerQuerySelector,
], (performanceHistory, routerQuery) => ({
  auth: routerQuery.auth,
  selectedJobInfo: performanceHistory.jobMetrics.get('jobInfo'),
  perfType: performanceHistory.common.get('perfType'),
}));

export const getPerfTypeSelector = createSelector([
  performanceHistoryStore,
  (store, options) => options,
], (performanceHistory, orderIndex) => {
  if (!orderIndex) {
    return performanceHistory.common.get('perfType');
  }
  return getPerfType(performanceHistory.jobMetrics.getIn(['jobData', orderIndex]).metric_data);
});
